import { useState, useEffect } from "react";

export default function useDeviceType() {
  const getType = () => {
    const width = window.innerWidth;

    if (width >= 1024) return "desktop";
    if (width >= 768) return "tablet";
    return "mobile";
  };

  const [device, setDevice] = useState(getType());

  useEffect(() => {
    const handler = () => setDevice(getType());
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return device;
}
